export default __webpack_public_path__ + "static/media/invoice-logo.1b017df6.png";